import _ from "lodash";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { createUseStyles } from "react-jss";
import { useTranslation } from "react-i18next";
import LanguageSelectorModal from "./LanguageSelectorModal";
import { getFlag, languageList } from "./helpers";
import jssVariables from "../../jss_setup";
import { useSelector } from "react-redux";

const styles = createUseStyles({
  LanguageSelector: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    width: "max-content",
    ..._.get(props.customStyles, "LanguageSelector", {}),
  }),
  titleMobile: (props) => ({
    cursor: "pointer",
    color: "white",
    fontSize: "medium",
    ..._.get(props.customStyles, "titleMobile", {}),
  }),
  icon: (props) => ({
    cursor: "pointer",
    borderRadius: "50%",
    width: `calc(${jssVariables.normal_gap} * 1.5)`,
    aspectRatio: "1/1",
    overflow: "hidden",
    border: "1px solid lightgray",
    ..._.get(props.customStyles, "icon", {}),
  }),
  langSelectorBtn: {
    cursor: "pointer",
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    LanguageSelector: (props) => ({
      display: "block",
      position: "relative",
      ..._.get(props.customStyles, "LanguageSelector.smallscreen", {}),
    }),
    icon: (props) => ({
      display: "block",
      ..._.get(props.customStyles, "icon.smallscreen", {}),
    }),
    titleMobile: (props) => ({
      display: "none",
      ..._.get(props.customStyles, "titleMobile.smallscreen", {}),
    }),
  },
});
const LanguageSelector = ({
  languages,
  customStyles,
  showLanguageModal,
  setShowLanguageModal,
}) => {
  const classes = styles({ customStyles });
  const { i18n } = useTranslation();
  const withLangFlags = useSelector(
    (state) => state?.WebsiteMetadata?.metadata?.language_flags ?? true
  );
  const [lang, ___] = i18n.language.toUpperCase().split("-");
  return (
    <span className={classes.LanguageSelector}>
      {withLangFlags ? (
        <div
          className={classes.icon}
          onClick={() => setShowLanguageModal(true)}>
          {getFlag(i18n.language.toUpperCase())}
        </div>
      ) : (
        <strong
          className={classes.langSelectorBtn}
          onClick={() => setShowLanguageModal(true)}>
          ( {lang} )
        </strong>
      )}
      <div
        className={classes.titleMobile}
        onClick={() => setShowLanguageModal(true)}>
        {
          languageList.find(
            (lang) => lang.flagText === i18n.language.toUpperCase()
          )?.label
        }
      </div>
      {showLanguageModal && (
        <LanguageSelectorModal
          languages={languages}
          showModal={showLanguageModal}
          closeLanguageModal={() => setShowLanguageModal(false)}
        />
      )}
    </span>
  );
};
LanguageSelector.defaultProps = {
  showLanguageModal: false,
  customStyles: {},
};
LanguageSelector.propTypes = {
  languages: PropTypes.array.isRequired,
  txtLogo: PropTypes.bool,
  showLanguageModal: PropTypes.bool.isRequired,
  setShowLanguageModal: PropTypes.func.isRequired,
  customStyles: PropTypes.object,
};

export default LanguageSelector;
